import axios from '@axios';

const getUserValidation = (token) => {
  return axios.get(`/user/${token}/validation`)
};

export default {
  getUserValidation,
};